import { createContext, useContext } from 'react';
import { normalizeSearchTerms } from '@/storybook/utils/normalizeSearchTerms';

type TableSearchHighlightContextValue = {
  searchValue: string | undefined;
  searchTerms: string[];
};

export const getTableSearchHighlightContextValue = (
  searchValue: string | undefined,
): TableSearchHighlightContextValue => ({
  searchValue,
  searchTerms: normalizeSearchTerms(searchValue),
});

const DEFAULT_TABLE_SEARCH_HIGHLIGHT_CONTEXT_VALUE = getTableSearchHighlightContextValue(undefined);

export const TableSearchHighlightContext = createContext<TableSearchHighlightContextValue>(
  DEFAULT_TABLE_SEARCH_HIGHLIGHT_CONTEXT_VALUE,
);

export const useTableSearchHighlight = (): string | undefined => {
  const searchHighlightValue = useContext(TableSearchHighlightContext);

  return searchHighlightValue.searchValue;
};

export const useTableSearchHighlightTerms = (): string[] => {
  const searchHighlightValue = useContext(TableSearchHighlightContext);

  return searchHighlightValue.searchTerms;
};